import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Classes, DialogStep, MultistepDialog, Radio, RadioGroup } from '@blueprintjs/core';
import { hasIn as xHasIn } from 'lodash';
import { TourPlayOptionsDialogContext, useTourPlayOptionsDialogContextContext } from './TourPlayOptionsDialog.Context';
import ListBox from './TourPlayOptionsDialog.ListBox';


function TourPlayOptionsDialogSelectTourPanel(props) {

    const {
        tours,
    } = props;

    const {
        selectedTourId,
        setSelectedTourId
    } = useTourPlayOptionsDialogContextContext();

    return (
        <div className={classNames(Classes.DIALOG_BODY)}  style={{color: '#182026'}}>
            <p>Select a tour to walkthrough.</p>
            <ListBox
                selectedItemId={selectedTourId}
                setSelectedItemId={id => setSelectedTourId(id)}
                items={tours.map(t => ({
                    id:t.id,
                    label:t.name,
                }))}
            />
        </div>
    );
}


TourPlayOptionsDialogSelectTourPanel.propTypes = {
    tours:PropTypes.array.isRequired,
}




function TourPlayOptionsDialogSetTourParameters(props) {

    const {
        tours
    } = props;
    const {
        selectedTourId,

        selectedDesignDate,
        selectedPanoDate,

        setSelectedDesignDate,
        setSelectedPanoDate
    } = useTourPlayOptionsDialogContextContext();

    const [ designDates, setDesignDates ] = useState([]);
    const [ panoDates, setPanoDates ] = useState([]);


    const selectedTour = tours.find(t => t.id === selectedTourId);

    useEffect(() => {
        let dDates = [];
        let pDates = [];

        if (xHasIn(selectedTour.data.dates, 2)) {
            pDates = selectedTour.data.dates[2].map(t => ({
                id:t,
                label:t,
            }));
            try {
                pDates.sort((a, b) => {
                    const ad = new Date(a.id);
                    const bd = new Date(b.id);
                    return ad < bd ? 1 : ad > bd ? -1 : 0;
                });
            } catch {}
        }
        if (xHasIn(selectedTour.data.dates, 3)) {
            dDates = selectedTour.data.dates[3].map(t => ({
                id:t,
                label:t,
            }));
            try {
                dDates.sort((a, b) => {
                    const ad = new Date(a.id);
                    const bd = new Date(b.id);
                    return ad < bd ? 1 : ad > bd ? -1 : 0;
                });
            } catch {}
        }
        setDesignDates(dDates);
        setPanoDates(pDates);
    }, [selectedTour, setDesignDates, setPanoDates]);


    useEffect(() => {
        if (selectedDesignDate.length &&
            designDates.findIndex(d => d.id === selectedDesignDate) < 0) {
            setSelectedDesignDate('');
        }
    }, [
        designDates, selectedDesignDate, setSelectedDesignDate,
    ]);

    useEffect(() => {
        if (selectedPanoDate.length &&
            panoDates.findIndex(d => d.id === selectedPanoDate) < 0) {
            setSelectedPanoDate('');
        }
    }, [
        panoDates, selectedPanoDate, setSelectedPanoDate
    ]);


    return (
        <div className={classNames(Classes.DIALOG_BODY)} style={{color: '#182026'}}>
            <p>Select tour parameters.</p>
            <div style={{display: 'flex', flexDirection:'row', gap: 8, width: '100%'}}>
                <div style={{flex:1}}>
                    <p>Design date</p>
                    <ListBox
                        selectedItemId={selectedDesignDate}
                        setSelectedItemId={setSelectedDesignDate}
                        items={designDates}
                    />
                </div>
                <div style={{flex:1}}>
                    <p>Panorama date</p>
                    <ListBox
                        selectedItemId={selectedPanoDate}
                        setSelectedItemId={setSelectedPanoDate}
                        items={panoDates}
                    />
                </div>
            </div>
        </div>
    );
}


TourPlayOptionsDialogSetTourParameters.propTypes = {
    tours:PropTypes.array.isRequired,
}





function TourPlayOptionsDialog(props, ref)
{
    const {
        tours,
        onPlayTour,
        onClose
    } = props;

    const [ selectedTourId, setSelectedTourId ] = useState(0);

    const [ selectedDesignDate, setSelectedDesignDate ] = useState('');
    const [ selectedPanoDate, setSelectedPanoDate ] = useState('');


    return (
        <TourPlayOptionsDialogContext.Provider value={{
            selectedTourId,
            selectedDesignDate,
            selectedPanoDate,

            setSelectedTourId,
            setSelectedDesignDate,
            setSelectedPanoDate
        }}>
            <MultistepDialog
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={false}
                enforceFocus={true}
                initialStepIndex={0}
                isOpen={true}
                usePortal={true}
                title={'Tour options'}
                finalButtonProps={{
                    intent: "primary",
                    onClick: () => onPlayTour(selectedTourId, selectedDesignDate, selectedPanoDate),
                    text: "Walk",
                    disabled:
                        ((selectedTourId || 0) < 1) ||
                        ((selectedDesignDate || '').length < 1) ||
                        ((selectedPanoDate || '').length < 1)
                }}
                onClose={onClose}
            >
                <DialogStep
                    id={'selectTour'}
                    panel={
                        <TourPlayOptionsDialogSelectTourPanel
                            tours={tours}
                        />
                    }
                    title={'Tour'}
                    nextButtonProps={{
                        disabled: (selectedTourId || 0) < 1
                    }}
                />
                <DialogStep
                    id={'selectCategoryAndDate'}
                    panel={
                        <TourPlayOptionsDialogSetTourParameters
                            tours={tours}
                        />
                    }
                    title={'Parameters'}
                    nextButtonProps={{
                        disabled:
                            ((selectedTourId || 0) < 1) ||
                            ((selectedDesignDate || '').length < 1) ||
                            ((selectedPanoDate || '').length < 1)
                    }}
                />
            </MultistepDialog>
        </TourPlayOptionsDialogContext.Provider>);
}


TourPlayOptionsDialog.propTypes = {
    tours:PropTypes.array.isRequired,
    onPlayTour:PropTypes.func.isRequired,
    onClose:PropTypes.func.isRequired,
}


export default React.forwardRef(TourPlayOptionsDialog);